export const GET_OPEN_EDITOR = "getOpenEditor";
export const IS_EDITOR_OPEN = "isEditorOpen";
